/**
 * Команды съёмки вслух (§22).
 *
 * Найдено на первой живой съёмке: читать текст и одновременно поворачивать
 * голову невозможно, а на записи в полный рост человек стоит в двух метрах
 * от экрана и не видит вообще ничего. Значит, команду надо не показывать,
 * а произносить.
 *
 * Речь берём у браузера: своих файлов не нужно, язык тот же, что
 * в интерфейсе, и работает без сети. Где её нет — экран остаётся
 * единственным способом, поэтому крупная надпись никуда не девается.
 */
import { useEffect, useRef } from 'react';

export function useSpokenCue(text: string, options: { enabled: boolean; locale: string }): void {
  const spoken = useRef<string | null>(null);

  useEffect(() => {
    if (!options.enabled || !text) return;
    // Каждую команду произносим один раз: она держится на экране несколько
    // секунд, и повторять её всё это время — только мешать.
    if (spoken.current === text) return;

    const speech = globalThis.speechSynthesis;
    if (!speech) return;

    spoken.current = text;

    // Прерываем прошлую: команда сменилась, и договаривать старую незачем.
    speech.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = options.locale;
    utterance.rate = 1;
    speech.speak(utterance);
  }, [text, options.enabled, options.locale]);

  // Уход со страницы посреди фразы не должен оставлять голос в эфире.
  useEffect(
    () => () => {
      globalThis.speechSynthesis?.cancel();
    },
    [],
  );
}
